class ProductSummary extends HTMLElement{constructor(){super(),this.priceContainer=this.querySelector("[data-price-content"),this.productImage=this.querySelectorAll("[data-product-image]"),this.handleProduct=this.querySelectorAll("[data-product-url]"),this.buttonAddToCart=this.querySelector("[data-add-cart]"),this.variants=this.querySelectorAll(".variants button.variant"),this.listeners()}listeners(){this.variants.forEach(t=>{t.addEventListener("click",t=>this.handleSelectVariant(t))}),this.buttonAddToCart.addEventListener("click",()=>this.addCart())}handleSelectVariant(t){var t=t.currentTarget,e=t.getAttribute("data-variant-image"),a=t.getAttribute("data-available"),r=t.getAttribute("data-variant-compare-price"),i=t.getAttribute("data-variant-price"),s=t.getAttribute("data-variant-id"),n=Number(t.getAttribute("data-max-parcelas")),o=Number(t.getAttribute("data-min-parcelas"));this.toggleVariantSelect(t),this.toggleImage(e),this.togglePrice(a,r,i),this.toggleButtonAddToCart(a),this.toggleURL("variant",s),this.calculateInstallments(Number(i),n,o)}toggleVariantSelect(t){this.variants.forEach(t=>t.classList.remove("variant--selected")),t.classList.add("variant--selected")}toggleURL(a,r){this.handleProduct.forEach(t=>{var e;t.href&&((e=new URL(t.href)).searchParams.set(a,r),t.href=e.pathname+e.search)})}toggleButtonAddToCart(t){this.buttonAddToCart.style.display="false"===t?"none":"block"}togglePrice(t,e,a){this.priceContainer&&(this.priceContainer.innerHTML="","false"===t?((t=document.createElement("span")).classList.add("available"),t.innerText="Indisponível",this.priceContainer.appendChild(t)):(0!==Number(e)&&((t=document.createElement("s")).classList.add("old-price"),t.innerText=this.formatarCurrency(Number(e)),this.priceContainer.appendChild(t)),(e=document.createElement("span")).classList.add("price"),e.innerText=this.formatarCurrency(Number(a)),this.priceContainer.appendChild(e)))}toggleImage(e){e&&this.productImage.forEach(t=>{t.src=e,t.srcset=e})}formatarCurrency(t){return(t/100).toLocaleString("pt-BR",{style:"currency",currency:window.Shopify.currency.active||"BRL"})}addCart(){try{this.buttonAddToCart.setAttribute("disabled","disabled");var t=Array.from([...this.variants]).find(t=>t.classList.contains("variant--selected")).getAttribute("data-variant-id"),r=fetchConfig("javascript");r.headers["X-Requested-With"]="XMLHttpRequest",delete r.headers["Content-Type"];let e=new FormData,a=document.querySelector("cart-notification")||document.querySelector("cart-drawer");a&&(e.append("sections",a.getSectionsToRender().map(t=>t.id)),e.append("sections_url",window.location.pathname),a.setActiveElement(document.activeElement)),e.append("utf8","✓"),e.append("form_type","product"),e.append("product-id",this.getAttribute("data-product-id")),e.append("id",t),e.append("quantity",1),r.body=e,fetch(""+routes.cart_add_url,r).then(t=>t.json()).then(t=>{t.status?publish(PUB_SUB_EVENTS.cartError,{source:"product-form",productVariantId:e.get("id"),errors:t.errors||t.description,message:t.message}):a?(publish(PUB_SUB_EVENTS.cartUpdate,{source:"product-form",productVariantId:e.get("id"),cartData:t}),a.renderContents(t)):window.location=window.routes.cart_url}).catch(t=>{console.error("Error:",t)}).finally(()=>{this.buttonAddToCart.removeAttribute("disabled"),a&&a.classList.contains("is-empty")&&a.classList.remove("is-empty")})}catch(t){window.location.href=this.handleProduct[0].href}}calculateInstallments(e,a,r){r=r||1,a=a||1;var i=this.querySelector("[data-installment-info]");if(i){r=100*r;if(r<=e){r=Math.floor(e/r);let t;if(1<(t=r<1?1:a<r?a:r))return a=e/t,void(i.innerHTML=`
                <span class="parcelas">
                    ( <span class="parcelas-bold">${t}x</span> de 
                    <span class="parcelas-bold">${this.formatarCurrency(a)}</span> )
                </span>
   
            `)}i.innerHTML='<span style="visibility:hidden;">(1x de 0,00)</span>'}}}customElements.define("product-summary",ProductSummary);class CardSlider extends HTMLElement{constructor(){super(),this.carousel=null,this.init()}init(){this.carousel=new Carousel(this,{infinite:!1,center:!1,slidesPerPage:"auto",transition:!1})}appendSlide(t){this.carousel.appendSlide({html:t})}}customElements.define("card-slider",CardSlider);class LocalStorageHandler extends HTMLElement{constructor(){super()}getValue(t){try{var e=localStorage.getItem(t);return JSON.parse(e)}catch(t){return console.error("Erro ao obter valor do localStorage:",t),null}}setValue(t,e){try{var a=JSON.stringify(e);localStorage.setItem(t,a)}catch(t){console.error("Erro ao definir valor no localStorage:",t)}}removeItem(t){try{localStorage.removeItem(t)}catch(t){console.error("Erro ao remover item do localStorage:",t)}}clearAll(){try{localStorage.clear()}catch(t){console.error("Erro ao limpar localStorage:",t)}}}class RecentlyView extends LocalStorageHandler{constructor(){super(),this.currentHandle=this.dataset.handle,this.maxItems=this.dataset.limit,this.key="OU_PRODUCTS_RECENTY_VIEW",this.products=[],this.targetElement=this.querySelector("card-slider"),this.init()}init(){this.getRegisterViews(),this.registreView(),this.pipeProducts()}getRegisterViews(){this.products=this.getValue(this.key)||[]}registreView(){this.products.includes(this.currentHandle)||(this.products.length==this.maxItems&&this.products.shift(),this.products.push(this.currentHandle),this.setValue(this.key,this.products),this.getRegisterViews())}pipeProducts(){let t=this.products;if((t=(t=t.filter(t=>t!==this.currentHandle)).filter(t=>!!t)).length<=0)this.style.display="none";else for(var[e,a]of t.entries()){if(e+1==this.maxItems)return void this.renderProduct(a);this.renderProduct(a)}}renderProduct(t){fetch(`/products/${t}?section_id=card-product`).then(t=>t.text()).then(t=>{const e=new DOMParser,r=e.parseFromString(t,"text/html").body.childNodes[0],s=r.querySelector(".product-card"),o=r.querySelector(".pdp-qty-modal");if(o){let t=document.getElementById("pdp-qty-drawers-root");t||(t=document.createElement("div"),t.id="pdp-qty-drawers-root",document.body.appendChild(t)),t.appendChild(o)}this.targetElement&&s&&this.targetElement.appendSlide(s)}).catch(t=>{console.error(t)})}}customElements.define("recenty-view",RecentlyView);class ShippingRates extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('[data-form="shipping-rates"]')
        this.ratesList = this.querySelector('[data-shipping-rates]')
        this.zipCode = this.querySelector('[data-zip-code]')
        this.button = this.querySelector('[data-form-show]')
        this.message = this.querySelector('[data-message]')
        this.location = this.getAttribute('data-location')
        this.shippingProgress = null
        this.storageKey = 'ou_shipping_location'

        this.init()
    }

    init() {
        this.form.addEventListener("submit", (event) => this.submit(event))

        this.form.querySelector("#zip-code")
            .addEventListener("input", (event) => this.maskZipCode(event))

        this.button.addEventListener("click", (event) => this.reset(event))

        this.tryRestoreLocation()
    }

    reset() {
        this.showElement(this.form)
        this.hideElement(this.ratesList)
        this.hideElement(this.zipCode)
        this.hideElement(this.message)
        this.clearStoredLocation()
        this.resetProgress()
    }

    async submit(event) {
        event.preventDefault();
        const { currentTarget } = event

        this.hideElement(this.message)
        const buttonSubmit = currentTarget.querySelector('button[type="submit"]');

        if (buttonSubmit) {
            buttonSubmit.setAttribute('disabled', 'true');
            buttonSubmit.innerHTML = 'Consultando...';
        }

        const formData = new FormData(currentTarget);
        const zip = formData.get('zip-code');

        try {
            const response = await fetch(`https://brasilapi.com.br/api/cep/v1/${zip.replace(/\D/g, '')}`);
            const { state, cep } = await response.json();
            const shippingRates = await this.fetchShippingRates(state, cep);

            this.displayShippingRates(shippingRates);
            this.updateButton(zip);
            this.updateFreeShippingProgress(state);
            this.saveLocation({ state, zip });

            this.sendDataLayer({
                event: 'shipping_calculate',
                category: 'shipping',
                zipCode: cep,
                shippingRates: shippingRates.shipping_rates.map((shipping) => ({
                    label: shipping.name,
                    value: shipping.price,
                    currency: shipping.currency,
                    deadline: shipping.delivery_days[0] || null,
                    source: shipping.source,
                })),
                pageType: this.location,
                url: window.location.href
            })
        } catch (error) {
            console.warn({ error });
            this.displayError(error.message);
        }

        if (buttonSubmit) {
            buttonSubmit.removeAttribute('disabled');
            buttonSubmit.innerHTML = 'Consultar';
        }
    }

    updateButton(zip) {
        const container = this.zipCode;
        container.querySelector("span").textContent = zip;

        this.showElement(this.zipCode);
    }

    saveLocation({ state, zip }) {
        if (!state) return;
        try {
            const data = { state, zip };
            localStorage.setItem(this.storageKey, JSON.stringify(data));
        } catch (e) {
            console.warn('Não foi possível salvar o CEP', e);
        }
    }

    clearStoredLocation() {
        try { localStorage.removeItem(this.storageKey); } catch(_) {}
    }

    tryRestoreLocation() {
        try {
            const raw = localStorage.getItem(this.storageKey);
            if (!raw) return;
            const data = JSON.parse(raw);
            if (!data || !data.state) return;
            if (data.zip) this.updateButton(data.zip);
            this.updateFreeShippingProgress(data.state);
        } catch (e) {
            console.warn('Erro ao restaurar CEP salvo', e);
        }
    }

    mapStateToGroup(state) {
        if (!state) return null;
        const uf = state.toUpperCase();
        const sulSudeste = ['RS', 'SC', 'PR', 'SP', 'RJ', 'MG', 'ES'];
        return sulSudeste.includes(uf) ? 'sul' : 'norte';
    }

    getProgressElement() {
        if (this.shippingProgress) return this.shippingProgress;
        const selector = this.location ? `[data-shipping-progress-location="${this.location}"]` : '[data-shipping-progress]';
        this.shippingProgress = document.querySelector(selector) || document.querySelector('[data-shipping-progress]');
        return this.shippingProgress;
    }

    resetProgress() {
        const container = this.getProgressElement();
        if (!container) return;
        const defaultMsg = container.dataset.defaultMessage || '';
        const titleEl = container.querySelector('[data-shipping-title]');
        const msgEl = container.querySelector('[data-shipping-message]');
        const bar = container.querySelector('.progress-bar');

        if (titleEl) titleEl.textContent = defaultMsg;
        if (msgEl) msgEl.textContent = defaultMsg;
        if (bar) {
            bar.style.width = '0%';
            bar.setAttribute('aria-valuenow', '0');
            const srOnly = bar.querySelector('.sr-only');
            if (srOnly) srOnly.textContent = '0% Complete';
        }
    }

    updateFreeShippingProgress(state) {
        const container = this.getProgressElement();
        if (!container) return;

        const group = this.mapStateToGroup(state);
        if (!group) return;

        const subtotal = Number(container.dataset.subtotalCents || 0);
        const threshold =
            group === 'sul'
                ? Number(container.dataset.thresholdSul || 0)
                : Number(container.dataset.thresholdNorte || 0);

        if (!threshold || threshold <= 0) return;

        const titleEl = container.querySelector('[data-shipping-title]');
        const msgEl = container.querySelector('[data-shipping-message]');
        const bar = container.querySelector('.progress-bar');

        const label = group === 'sul' ? (container.dataset.labelSul || 'Frete grátis Sul/Sudeste') : (container.dataset.labelNorte || 'Frete grátis');
        const remaining = Math.max(0, threshold - subtotal);
        const percentage = Math.max(0, Math.min(100, subtotal * 100 / threshold));

        if (msgEl) {
            msgEl.innerHTML = remaining <= 0
                ? `Você ganhou frete grátis em ${label}.`
                : `Faltam apenas <span class="value">${(remaining / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span> para Frete Grátis em ${label}.`;
        }

        if (bar) {
            bar.style.width = `100%`;
            bar.setAttribute('aria-valuenow', `100`);
            const srOnly = bar.querySelector('.sr-only');
            if (srOnly) srOnly.textContent = `Progresso visível apenas no texto.`;
        }
    }

    displayShippingRates(shippingRates) {
        if (!shippingRates || !shippingRates.shipping_rates || shippingRates.shipping_rates.length === 0) {
            throw new Error('Erro ao carregar a cotação. Tente novamente');
        }

        const fragment = document.createDocumentFragment();
        shippingRates.shipping_rates.forEach(rate => fragment.appendChild(this.createRateElement(rate)));

        this.ratesList.innerHTML = '';
        this.ratesList.appendChild(fragment);
        this.showElement(this.ratesList);
        this.hideElement(this.form)
    }

    createRateElement(rate) {
        const rateContainer = this.createElementWithClass('li', 'list-shipping-rates__item');
        const rateTitle = this.createElementWithClass('span', 'rate__title', rate.name);
        let rateContent;

        if (rate.delivery_days[0]) {
            rateContent = this.createElementWithClass('span', 'rate__content', `Em até ${rate.delivery_days[0]} dias úteis - R$ ${rate.price}`);
        } else {
            rateContent = this.createElementWithClass('span', 'rate__content', 'Frete grátis');
        }

        rateContainer.append(rateTitle, rateContent);

        return rateContainer;
    }

    createElementWithClass(tag, className, textContent = '') {
        const element = document.createElement(tag);
        element.classList.add(className);
        element.textContent = textContent;

        return element;
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async fetchShippingRates(province, zip) {
        const country = 'BR';
        const payload = JSON.stringify({
            shipping_address: { country, province, zip }
        });

        try {
            await this.requestShippingRates('/cart/prepare_shipping_rates', payload);
 // Aumentar o tempo de espera para dar tempo ao servidor processar
            await this.sleep(3000);
            // Adicionar tentativas múltiplas para a segunda requisição
            let attempts = 0;
            let maxAttempts = 3;
            let shippingRates = null;
            while (attempts < maxAttempts) {
                shippingRates = await this.requestShippingRates('/cart/async_shipping_rates');
                // Verificar se temos taxas de envio válidas
                if (shippingRates?.shipping_rates?.length) {
                    return shippingRates;
                }
                // Se não tiver taxas válidas, esperar e tentar novamente
                await this.sleep(1000);
                attempts++;
            }
            // Se chegou aqui, retorna o último resultado obtido
            return shippingRates;
        } catch (error) {
            console.error("Erro ao buscar taxas de envio:", error);
            throw new Error('Não conseguimos consultar, tente novamente ou entre em contato com nosso atendimento.');
        }
    }

    async requestShippingRates(url, body = null) {
        const options = body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body } : {};
        const response = await fetch(url, options);
        const text = await response.text();

        if (!response.ok) {
            console.warn('Shipping rates response error:', text);
            try {
                const data = JSON.parse(text);
                throw new Error(data.message || 'Não conseguimos consultar, tente novamente ou entre em contato com nosso atendimento.');
            } catch (e) {
                throw new Error('Não conseguimos consultar, tente novamente ou entre em contato com nosso atendimento.');
            }
        }

        try {
            return JSON.parse(text);
        } catch (e) {
            throw new Error('Não conseguimos consultar, tente novamente ou entre em contato com nosso atendimento.');
        }
    }

    showElement(element) {
        element.classList.remove('hidden');
    }

    hideElement(element) {
        element.classList.add('hidden');
    }

    maskZipCode(event) {
        const input = event.currentTarget

        if (input.value.length >= 9) {
            return
        }

        let cep = input.value.replace(/\D/g, '');

        if (cep.length > 5) {
            cep = cep.replace(/^(\d{5})(\d{1,3})/, '$1-$2');
        }

        input.value = cep;
    }

    displayError(message) {
        this.message.textContent = message;
        this.message.style.color = '#3e3e3d';
        this.showElement(this.message);
    }

    sendDataLayer(data) {
        try {
            Shopify.analytics.publish(PUB_SUB_EVENTS.shippingCalculate, data);
        } catch (error) {
            console.error("Erro ao enviar dados para o Data Layer:", error);
        }
    }
}

customElements.define('shipping-rates', ShippingRates);class productKitVariants extends HTMLElement{constructor(){super(),this.btnVariant=this.querySelectorAll(".btn-variant"),this.pricesVariant=this.querySelectorAll(".products-for-kits"),this.selectedValue=this.querySelector("[data-selected-value]"),this.input=document.querySelector('input[name="id"]'),this.controls=this.querySelector("[data-controls]"),this.buttonAddToCart=this.querySelector("[data-add-cart]"),this.qtda=this.querySelector("[data-qtda]"),this.plus=this.querySelector("[data-plus]"),this.minus=this.querySelector("[data-minus]"),this.init()}connectedCallback(){this.handleDisabeldButton()}init(){this.btnVariant.forEach(t=>{t.addEventListener("click",t=>this.handleSelectVariant(t))}),this.plus.addEventListener("click",()=>this.handleQtda(1)),this.minus.addEventListener("click",()=>this.handleQtda(-1)),this.qtda.addEventListener("change",t=>this.handleChangeQtda(t)),this.buttonAddToCart.addEventListener("click",()=>this.addCart())}addCart(){this.buttonAddToCart.setAttribute("disabled","disabled");var t=Array.from(this.pricesVariant).find(t=>"true"==t.getAttribute("data-select")),e=t.getAttribute("data-ids");let a=t.getAttribute("data-variant-id"),r=t.getAttribute("data-kit-name");t=e.split(",").filter(t=>!!t).map(t=>{var[t,e]=t.split("|");return{id:t,quantity:e*this.qtda.value,properties:{kit:r,kitName:"#"+a}}});null!=t&&fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:t})}).then(t=>t.json()).then(async t=>{await this.cartUpdate()}).catch(t=>{console.error("Error:",t)}).finally(()=>{this.buttonAddToCart.removeAttribute("disabled")})}async cartUpdate(){await fetch(routes.cart_url+"?section_id=cart-drawer").then(t=>t.text()).then(t=>{var e,a=(new DOMParser).parseFromString(t,"text/html");for(e of["cart-drawer"]){var r=document.querySelector(e),i=a.querySelector(e);r&&i&&r.replaceWith(i)}}).catch(t=>{console.error(t)}).finally(()=>{var t=document.querySelector("cart-notification")||document.querySelector("cart-drawer");t&&t.classList.contains("is-empty")&&t.classList.remove("is-empty"),t?t.open():window.location=window.routes.cart_url})}handleDisabeldButton(){this.pricesVariant.forEach(t=>{"true"==t.getAttribute("data-select")&&("false"===t.getAttribute("data-available")?(this.buttonAddToCart.setAttribute("disabled",!0),this.controls.style.display="none"):(this.buttonAddToCart.removeAttribute("disabled"),this.controls.style.display="flex"))})}handleQtda(t){var e=parseInt(this.qtda.value);this.qtda.value=e+t,this.qtda.dispatchEvent(new Event("change",{bubbles:!0}))}handleChangeQtda(t){var e=Array.from(this.pricesVariant).find(t=>"true"==t.getAttribute("data-select")),e=parseInt(e.getAttribute("max-kits")),t=t.currentTarget,a=parseInt(t.value);1==a||a<1?(t.value=1,this.minus.setAttribute("disabled",!0)):this.minus.removeAttribute("disabled"),e<=a?(t.value=e,this.plus.setAttribute("disabled",!0)):this.plus.removeAttribute("disabled")}handleSelectVariant(t){var t=t.currentTarget,e=t.getAttribute("data-variant-id"),a=t.getAttribute("data-option-value-id"),r=t.getAttribute("data-target");this.btnVariant.forEach(t=>{t.setAttribute("data-select",!1)}),t.setAttribute("data-select",!0),this.selectedValue.innerText=t.getAttribute("title"),this.updateURLParams(e),this.togglePrice(r),this.productUpdate(a),this.handleDisabeldButton()}updateURLParams(t){var e=new URL(window.location.href);t&&e.searchParams.set("variant",t),window.history.replaceState({},"",e)}togglePrice(e){this.pricesVariant.forEach(t=>{t.setAttribute("data-select",!1),t.classList.contains(e)&&t.setAttribute("data-select",!0)})}productUpdate(t){var e=document.querySelector("product-info"),a=e.getAttribute("data-section"),e=e.getAttribute("data-url");fetch(e+`?section_id=${a}&option_values=`+t).then(t=>t.text()).then(t=>{var e,a=(new DOMParser).parseFromString(t,"text/html");for(e of["product-info"]){var r=document.querySelector(e),i=a.querySelector(e);r&&i&&r.replaceWith(i)}}).catch(t=>{console.error(t)})}}
